var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"map",attrs:{"center":_vm.computedCenter,"zoom":_vm.computedZoom,"options":_vm.mapOptions}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }